export default __webpack_public_path__ + "static/media/built-by-intelligence.e277cf26.png";